import { withNamespaces } from "react-i18next";
import { Dropdown, DropdownToggle } from "reactstrap";

// Placeholder for future dashboard-wide filters.
const FilteringComponent = ({ t }) => {
  return (
    <Dropdown isOpen={false} toggle={() => {}}>
      <DropdownToggle color="light" className="d-flex align-items-center">
        <i className="ri-filter-3-line me-1" />
        {t("Filter")}
      </DropdownToggle>
    </Dropdown>
  );
};

export default withNamespaces()(FilteringComponent);
